<woa-full-page-layout [pillarboxedOnDesktop]="'double-mobile'"
                      [showContent]="!hideDetails() && loadingStatus() === LoadingStatus.LOADED" [showNavbarLogo]="true"
                      [showFooter]="showFooter() && orderModel.orderInitiationStatus() === OrderInitiationStatus.INITIATED"
                      [showFooterShadow]="true">
    @if (loadingStatus() === LoadingStatus.FAILED) {
        <woa-content-message [level]="MessageLevel.ERROR"
                             [text]="'woa.error.order.initiationFailed'" [link]="'woa.button.common.retry'"
                             (onLinkActivate)="load()"></woa-content-message>
    }
    @if (orderModel.orderInitiationStatus() === OrderInitiationStatus.FAILED && orderModel.initiationErrorKey()) {
        <woa-content-message [level]="MessageLevel.ERROR"
                             [text]="orderModel.initiationErrorKey()" [link]="'woa.button.common.retry'"
                             [translationParams]="orderModel.initiationErrorParams()"
                             (onLinkActivate)="orderModel.requestOrderInitiation('ordering page - initiation error retry')"></woa-content-message>
    }
    @if (responsiveService.desktop()) {
        <woa-order-details-panel class="order-details" slot="content-left"
                                 [recentOrder]="recentOrder()" [showPayment]="false"></woa-order-details-panel>
    }
    @if (!orderingContextModel.isConfirmedTableOrdering()) {
        <div class="ordering-context" woa-responsive slot="content-right">
            <woa-ordering-context-panel [timeOnly]="true"></woa-ordering-context-panel>
            @if (orderModel.orderErrorStates().orderWithInvalidTimeAttempted()) {
                <woa-content-message [level]="MessageLevel.ERROR" [text]="orderModel.invalidOrderTimeMessage()"
                                     [translationParams]="{storeName: orderingContextModel.currentStore()?.collectiveStoreName}"
                                     [closable]="true"
                                     (onClose)="orderModel.orderErrorStates().orderWithInvalidTimeAttempted.set(false)"></woa-content-message>
            }
        </div>
    }
    <woa-form class="order-placement" woa-responsive slot="content-right" (onSubmit)="placeOrder()">
        @if (orderModel.paymentRequired()) {
            <woa-field-group class="order-placement-options" [title]="'woa.heading.payment.paymentOptions'">
                @if (this.nrPaymentOptions() === 0) {
                    <woa-content-message [level]="MessageLevel.ERROR"
                                         [text]="'woa.error.payment.noPaymentMethodsAvailable'"></woa-content-message>
                }
                @if (paymentModel.canTapToPay()) {
                    <woa-radio-field [label]="'woa.label.payment.tapToPay'"
                                     [selected]="configurationModel.isWaiterActor()"
                                     (selectedChange)="setPaymentType(PaymentType.TAP_TO_PAY)">
                        <woa-icon class="tap-to-pay" [name]="'tap-to-pay'"></woa-icon>
                    </woa-radio-field>
                }
                @if (configurationModel.isConsumerActor() || allowConsumerPaymentTypes()) {
                    @for (target of orderModel.initiatedOrder().availableTransferTargets; track target) {
                        <woa-radio-field [label]="'woa.label.payment.payWithGroupOrder'"
                                         [translationParams]="{'groupOrderName': target.name | possessive}"
                                         [selected]="paymentType() === PaymentType.GROUP_PAY && transferTarget() === target"
                                         (selectedChange)="selectTransferTarget(target)">
                            <woa-icon [name]="'users'"></woa-icon>
                        </woa-radio-field>
                    }
                    @if (paymentModel.canMakeApplePayPayment()) {
                        <woa-radio-field [label]="'woa.label.payment.payWithApplePay'"
                                         [selected]="paymentType() === PaymentType.APPLE_PAY"
                                         (selectedChange)="setPaymentType(PaymentType.APPLE_PAY)">
                            <woa-icon class="apple-pay-mark" [name]="'apple-pay-mark'"></woa-icon>
                        </woa-radio-field>
                    }
                    @if (paymentModel.canMakeGooglePayPayment()) {
                        <woa-radio-field [label]="'woa.label.payment.payWithGooglePay'"
                                         [selected]="paymentType() === PaymentType.GOOGLE_PAY"
                                         (selectedChange)="setPaymentType(PaymentType.GOOGLE_PAY)">
                            <woa-icon class="google-pay-mark" [name]="'google-pay-mark'"></woa-icon>
                        </woa-radio-field>
                    }
                    @if (showSavedCreditCardPayment()) {
                        <woa-radio-field [label]="'woa.label.payment.payWithSavedCard'"
                                         [translationParams]="{'cardLast4': paymentModel.cardLast4()}"
                                         [selected]="paymentType() === PaymentType.SAVED_CREDIT_CARD"
                                         (selectedChange)="setPaymentType(PaymentType.SAVED_CREDIT_CARD)">
                            <woa-card-brand [brand]="paymentModel.cardBrand()"></woa-card-brand>
                            <woa-link slot="action" [link]="'woa.button.payment.forgetCard'"
                                      (onActivate)="forgetCard()"></woa-link>
                        </woa-radio-field>
                    }
                    @if (showNewCreditCardPayment()) {
                        <woa-radio-field #newCard [softResizeOnSelect]="true"
                                         [label]="showSavedCreditCardPayment() ? 'woa.label.payment.payWithNewCard' : 'woa.label.payment.payWithCard'"
                                         [selected]="paymentType() === PaymentType.NEW_CREDIT_CARD"
                                         (selectedChange)="setPaymentType(PaymentType.NEW_CREDIT_CARD)"
                                         (onActivateLabel)="copyDefaultCardNr()">
                            <woa-card-brand [brand]="'Visa'"></woa-card-brand>
                            <woa-card-brand [brand]="'Mastercard'"></woa-card-brand>
                            <woa-card-brand [brand]="'Amex'"></woa-card-brand>
                            @if (paymentModel.paymentProvider() === IntegratedPaymentProvider.STRIPE) {
                                <woa-stripe-manual-payment-card-panel slot="details"
                                                                      [disabled]="orderModel.orderSubmissionStatus() === OrderSubmissionStatus.SUBMITTING"></woa-stripe-manual-payment-card-panel>
                            }
                            @if (paymentModel.paymentProvider() === IntegratedPaymentProvider.TYRO) {
                                <woa-tyro-manual-payment-card-panel slot="details"
                                                                    [hidden]="paymentType() !== PaymentType.NEW_CREDIT_CARD"
                                                                    [disabled]="orderModel.orderSubmissionStatus() === OrderSubmissionStatus.SUBMITTING"
                                                                    (onPayFormReady)="newCard.setHeight()"></woa-tyro-manual-payment-card-panel>
                            }
                            @if (paymentModel.paymentProvider() === IntegratedPaymentProvider.OOLIO) {
                                <woa-adyen-manual-payment-card-panel slot="details"
                                                                     [hidden]="paymentType() !== PaymentType.NEW_CREDIT_CARD"
                                                                     [disabled]="orderModel.orderSubmissionStatus() === OrderSubmissionStatus.SUBMITTING"
                                                                     (onPayFormReady)="newCard.setHeight()"></woa-adyen-manual-payment-card-panel>
                            }
                        </woa-radio-field>
                    }
                    @if (showPointsPayment()) {
                        <woa-radio-field [disabled]="!canPayWithPoints()"
                                         [label]="canPayWithPoints() ? 'woa.label.payment.payWithPoints' : 'woa.label.payment.pointsRequired'"
                                         [message]="'woa.message.payment.pointsBalance'"
                                         [translationParams]="{
                                             'amount': orderModel.initiatedOrder()?.memberAvailableRedemptionPoints,
                                             'required': orderModel.initiatedOrder()?.pointsRedeemable,
                                             'balance': orderModel.initiatedOrder()?.memberPointsBalance
                                         }"
                                         [selected]="paymentType() === PaymentType.POINTS"
                                         (selectedChange)="setPaymentType(PaymentType.POINTS)">
                            <woa-icon [name]="'star'"></woa-icon>
                        </woa-radio-field>
                    }
                }
            </woa-field-group>
        }
        @if (orderingContextModel.isConfirmedDeliveryOrdering()) {
            <woa-field-group #deliveryDetails
                             [title]="'woa.heading.payment.deliveryDetails'">
                @if (showPhoneNumberField()) {
                    <woa-phone-number-field [(ngModel)]="mobilePhone" name="mobilePhone"
                                            [label]="'woa.label.common.mobile'"
                                            [required]="orderingContextModel.requirePhoneNumber()" woa-phone-number></woa-phone-number-field>
                }
                <woa-text-area-field [(ngModel)]="orderingContextModel.deliveryInstructions" name="deliveryInstructions"
                                     [label]="'woa.label.address.deliveryInstructions'"
                                     [maxlength]="'255'"></woa-text-area-field>
            </woa-field-group>
        }
        @if (showCustomerDetails()) {
            <woa-field-group #customerDetails
                             class="order-placement-customer-details" [title]="'woa.heading.payment.customerDetails'">
                @if (showNameField()) {
                    <woa-field-pair>
                        <woa-text-field [(ngModel)]="firstName" name="firstName"
                                        [label]="'woa.label.common.firstName'"
                                        [required]="requireFirstName()" [maxlength]="'30'"
                                        [autocomplete]="'given-name'" [spellcheck]="false"></woa-text-field>
                        <woa-text-field [(ngModel)]="lastName" name="lastName"
                                        [label]="'woa.label.common.lastName'"
                                        [required]="requireLastName()" [maxlength]="'30'"
                                        [autocomplete]="'family-name'" [spellcheck]="false"></woa-text-field>
                    </woa-field-pair>
                }
                @if (showEmailField()) {
                    <woa-email-field [(ngModel)]="email" name="email" [label]="emailLabel()"
                                     [required]="requireEmail()" woa-email></woa-email-field>
                }
                @if (showPhoneNumberField() && !orderingContextModel.isConfirmedDeliveryOrdering()) {
                    <woa-phone-number-field [(ngModel)]="mobilePhone" name="mobilePhone"
                                            [label]="'woa.label.common.mobile'"
                                            [required]="requirePhoneNumber()" woa-phone-number></woa-phone-number-field>
                }
                @if (orderingContextModel.showMarketingOptIn()) {
                    <woa-selector-control class="order-placement-customer-details-marketing"
                                          [(selected)]="orderingContextModel.marketingOptIn"
                                          [label]="'woa.label.common.marketingOptIn'"></woa-selector-control>
                }
            </woa-field-group>
        }
        @if (showTips()) {
            <woa-tip-selection-panel class="order-placement-tip"
                                     [showTipInstructions]="true"
                                     [(tipAmount)]="orderModel.tipAmount"
                                     [(tipSelected)]="orderingContextModel.tipSelected"
                                     (tipAmountChange)="tipChanged()"></woa-tip-selection-panel>
        }
    </woa-form>
    <woa-order-totals-panel slot="footer-start" class="payment-totals" [totalOnly]="true"></woa-order-totals-panel>
    @if (paymentType() === PaymentType.NONE) {
        <woa-button woa-page-footer-control
                    id="no-pay-button" [label]="'woa.button.payment.placeOrder'"
                    [disabled]="configurationModel.timeTestMode()"
                    (onActivate)="form().submit()"></woa-button>
    }
    @if (paymentType() === PaymentType.TAP_TO_PAY) {
        <woa-button woa-page-footer-control
                    id="tap-to-pay-button" [label]="'woa.button.payment.tapToPay'"
                    [disabled]="configurationModel.timeTestMode()"
                    (onActivate)="form().submit()"></woa-button>
    }
    @if (paymentType() === PaymentType.GROUP_PAY) {
        <woa-button woa-page-footer-control
                    id="group-pay-button" [label]="'woa.button.payment.payWithGroupOrder'"
                    [disabled]="configurationModel.timeTestMode()"
                    (onActivate)="form().submit()"></woa-button>
    }
    @if (paymentType() === PaymentType.APPLE_PAY) {
        <woa-apple-pay-button woa-page-footer-control
                              id="apple-pay-button" [passiveOnly]="true"
                              [type]="paymentModel.walletPaymentProcessor().canSubmit ? 'plain' : 'check-out'"
                              [disabled]="configurationModel.timeTestMode()"
                              (pay)="form().submit()"></woa-apple-pay-button>
    }
    @if (paymentType() === PaymentType.GOOGLE_PAY) {
        <woa-google-pay-button woa-page-footer-control
                               id="google-pay-button" [passive]="true"
                               [type]="paymentModel.walletPaymentProcessor().canSubmit ? 'plain' : 'checkout'"
                               [disabled]="configurationModel.timeTestMode()"
                               (pay)="form().submit()"></woa-google-pay-button>
    }
    @if (paymentType() === PaymentType.SAVED_CREDIT_CARD || paymentType() === PaymentType.NEW_CREDIT_CARD) {
        <woa-button woa-page-footer-control
                    id="credit-card-pay-button" [label]="'woa.button.payment.payWithCard'"
                    [translationParams]="{'amount': (orderModel.orderTotalPayment() | woaCurrency: 'AU$')}"
                    [disabled]="configurationModel.timeTestMode()"
                    (onActivate)="form().submit()"></woa-button>
    }
    @if (paymentType() === PaymentType.POINTS) {
        <woa-button woa-page-footer-control
                    id="points-pay-button" [label]="'woa.button.payment.payWithPoints'"
                    [translationParams]="{'amount': orderModel.initiatedOrder()?.memberAvailableRedemptionPoints}"
                    [disabled]="configurationModel.timeTestMode()"
                    (onActivate)="form().submit()"></woa-button>
    }
    <woa-legal-panel slot="footer-end" class="payment-legal" [messageSet]="'payment'"></woa-legal-panel>
</woa-full-page-layout>
